import { useState } from 'react';

// Keeps the last non-null value while a modal animates closed. Callers
// usually clear the value that drives `open` (e.g. `productId`) as they close,
// which blanked / reflowed the modal body mid-animation. Pass `release` to the
// modal's `afterClose` to drop the retained value once it is fully hidden.
//
//   const [line, release] = useRetainedWhileClosing(editingLine);
//   <AppModal open={Boolean(editingLine)} afterClose={release}>
//     {line ? <ProductDetailView productId={line.itemId} … /> : null}
export function useRetainedWhileClosing(value) {
  const [retained, setRetained] = useState(value ?? null);
  if (value != null && value !== retained) setRetained(value);
  const release = () => setRetained(null);
  return [value ?? retained, release];
}
